<template>
  <b-button variant="outline-info" v-on:click="pressed">{{$t("EDIT")}}</b-button>
</template>
<script>

export default {
  props: ["Tenant"],
  methods: {
    pressed: function(event) {
      event.preventDefault();

      this.$emit('EditTenant', this.Tenant);
    }
  }
};
</script>